export default __webpack_public_path__ + "static/media/logo_360prwire.75a7353d.png";